<template>
  <kpi-card
    :value="kpi?.sla"
    :valueAsPercentage="valueAsPercentage"
    :maxWarningValue="maxWarningValue"
    :maxDangerValue="maxDangerValue"
    :title="$t('home.avg_handle_time')"
    :unit="$t('home.sec')"
    flipped
  />
</template>

<script>
import KpiCard from "./KpiCard.vue";
export default {
  components: {
    KpiCard,
  },
  props: ["kpi"],
  computed: {
    // Dynamic maximum value that adapts to the data
    maxScaleValue() {
      return Math.max(
        this.kpi?.sla || 0,
        this.kpi?.threshold || 0, 
        this.kpi?.critical || 0,
        100 // Minimum baseline
      ) * 2;
    },
    valueAsPercentage() {
      return (this.kpi?.sla / this.maxScaleValue) * 100;
    },
    maxWarningValue() {
      return (this.kpi?.threshold / this.maxScaleValue) * 100;
    },
    maxDangerValue() {
      return (this.kpi?.critical / this.maxScaleValue) * 100;
    },
  },
};
</script>

<style></style>
